import React, { ReactNode } from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

interface IProps {
  onClose: () => void;
  visible: boolean;
  isDefault: boolean;
  title?: string;
  onClear?: () => void;
  children?: ReactNode;
  className?: string;
  onDone: () => void;
  "data-qa"?: string;
}

const Menu = ({
  onClose,
  visible,
  isDefault,
  title = "",
  onClear = () => {},
  children = null,
  className = "",
  onDone,
  "data-qa": dataQa = "menu",
  ...rest
}: IProps) => {
  const menuInnerStyles = cn(
    styles.menuInner,
    visible && styles.visible,
    className
  );

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <section className={styles.menu} data-qa={dataQa} {...rest}>
      <div className={menuInnerStyles}>
        <header className={styles.header}>
          <p className={styles.title}>{title}</p>
          <button
            className={styles.closeButton}
            onClick={onClose}
            test-selector="close-button"
            type="button"
          >
            ×
          </button>
        </header>

        {children}

        <footer className={styles.footer}>
          <button
            onClick={onDone}
            className={styles.doneButton}
            test-selector="done-button"
            data-qa="menu-done-button"
            type="button"
          >
            Done
          </button>
          {onClear && !isDefault && (
            <button
              onClick={onClear}
              className={styles.clearButton}
              test-selector="clear-button"
              data-qa="menu-clear-button"
              type="button"
            >
              Clear
            </button>
          )}
        </footer>
      </div>
    </section>
  );
};

export default Menu;
